import React from 'react';
import ExpenseResolutionType2Workspace from './ExpenseResolutionType2Workspace';

/** 지출결의등록(type2) — 결의서 양식 직접 입력 */
export default function ExpenseResolutionRegisterType2() {
  return <ExpenseResolutionType2Workspace />;
}
